import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibTextarea } from '@chewy/kib-fields-new-react'
import type { Field } from '@pbt/pbt-ui-components'

import styles from './OrderItemReceipt.module.scss'

interface OrderItemReceiptNotesProps {
  field: Field
  isDisabled: boolean
  isDraft: boolean
  required: boolean
}

export const OrderItemReceiptNotes = ({
  field,
  isDisabled,
  isDraft,
  required,
}: OrderItemReceiptNotesProps) => {
  const { t } = useTranslation('Common')

  const hasExistingNotes = Boolean(field.initialValue ?? field.value)

  const [isExpanded, setIsExpanded] = useState(hasExistingNotes)

  useEffect(() => {
    if (required) {
      setIsExpanded(true)
    } else if (!field.value) {
      setIsExpanded(false)
    }
  }, [required, field.value])

  if (isDraft) {
    if (isExpanded) {
      return (
        <KibTextarea
          disabled={isDisabled}
          invalid={field.errors.length > 0}
          label={required ? `${field.label!} *` : field.label!}
          messagesContent={field.message}
          value={field.value ?? ''}
          onChange={(e) => field.setValue(e.target.value)}
        />
      )
    }

    return (
      <KibButtonNew
        className={styles.addNoteLink}
        disabled={isDisabled}
        onClick={() => setIsExpanded(true)}
      >
        {t('Common:ADD_NOTE')}
      </KibButtonNew>
    )
  }

  if (field.value) {
    return (
      <div className={styles.notesReadOnly}>
        <span className={styles.notesLabel}>{field.label}</span>
        <p className={styles.notesText}>{field.value}</p>
      </div>
    )
  }

  return null
}
